var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-development"},[_c('div',{staticClass:"content"},[_c('MarkdownMobileView',{attrs:{"textData":_vm.textData,"title":_vm.title}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }